import $ from 'jquery';
import { Component } from '../../../component';

export class Dropdown extends Component {
	/**
	 * setup
	 */
	setup() {
		const $el = $( '.js-c-dropdown' );
		if ( ! $el.length ) return;

		// Scrollbar support
		if ( $.fn.fsScrollbar !== undefined ) {
			$.fn.fsScrollbar = undefined;
		}

		Formstone.isMobile = false;

		$el.dropdown();

		$el.closest( '.fs-dropdown' ).on( 'close.dropdown', (evt) => {
			var value = $( 'option:selected', $( evt.target ).find( $el ) ).val();
			if ( '' !== value ) {
				$( this )
					.find( '.fs-dropdown-selected' )
					.addClass( 'fs-dropdown-isfilled' );
			}
			else {
				$( this )
					.find( '.fs-dropdown-selected' )
					.removeClass( 'fs-dropdown-isfilled' );
			}
		} );

		$el.on( 'change', function() {
			var value = $( 'option:selected', this ).val();

			if ( '' !== value ) {
				$( this ).closest( '.fs-dropdown' )
					.find( '.fs-dropdown-selected' )
					.addClass( 'fs-dropdown-isfilled' );
			}
			else {
				$( this ).closest( '.fs-dropdown' )
					.find( '.fs-dropdown-selected' )
					.removeClass( 'fs-dropdown-isfilled' );
			}
		} );
	}
}
